import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseService} from './base.service';
import {Observable} from 'rxjs';
import {AlertService} from './alert.service';
import {GlobalService} from './global.service';
import {AppUrl} from '../constants/app-url';
import * as http from 'http';

@Injectable({
    providedIn: 'root'
})
export class CourseService extends BaseService {
    constructor(public http: HttpClient,
                public alertService: AlertService,
                public globalService: GlobalService) {
        super(http, alertService, globalService);
    }
    getCourse(data): Observable<any> {
        return this.getRequest(AppUrl.ALL_CONTACT(), data);
    }

}
